import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import type { IArea } from '../interfaces/IArea';

export default function Edit() {
  const { register, handleSubmit, control, setValue: setFormValue, getValues, watch, resetField } = useForm<IArea>();
  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string' },
    { name: 'acronym', type: 'string' },
    { name: 'polygon', type: 'string' },
    { name: 'area_plan_id', type: 'selectAutoComplete', model: 'area-plan', placeholder: 'Mapa', required: true },
    { name: 'color', type: 'string' },
  ];

  return (
    <CrudEdit model={'area'}
      fields={fields}
      register={register}
      handleSubmit={handleSubmit}
      control={control}
      setFormValue={setFormValue}
      messageSuccess={'Area successfully updated!'}
      title={'Edit area'}
      getValues={getValues}
      watch={watch}
      resetField={resetField}
    />
  )
}
